import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    fieldArrayItemHeading: {
        marginTop: theme.spacing(2),
        fontWeight: 'bold',
        textTransform: 'uppercase',
    },
    fieldArrayButton: {
        marginTop: theme.spacing(2),
    },
    fieldArrayDivider: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    formLabel: {
        margin: 0,
    },
    formControl: {},
}));
